'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = exports.propTypes = {
  boxSizing: _propTypes2.default.string,
  clear: _propTypes2.default.string,
  clearfix: _propTypes2.default.bool,
  display: _propTypes2.default.string,
  float: _propTypes2.default.string,
  zIndex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
var propAliases = exports.propAliases = {};
var propValidators = exports.propValidators = {};
var _display = {
  className: 'dspl',
  cssName: 'display',
  jsName: 'display',
  safeValue: true,
  isPrefixed: true
};
var _float = {
  className: 'flt',
  cssName: 'float',
  jsName: 'float',
  safeValue: true
};
var _clear = {
  className: 'clr',
  cssName: 'clear',
  jsName: 'clear',
  safeValue: true
};
var _zIndex = {
  className: 'z-idx',
  cssName: 'z-index',
  jsName: 'zIndex',
  safeValue: true,
  defaultUnit: ''
};
var _boxSizing = {
  className: 'box-szg',
  cssName: 'box-sizing',
  jsName: 'boxSizing',
  safeValue: true
};
var propEnhancers = exports.propEnhancers = {
  boxSizing: function boxSizing(value) {
    return (0, _getCss2.default)(_boxSizing, value);
  },
  clear: function clear(value) {
    return (0, _getCss2.default)(_clear, value);
  },
  clearfix: function clearfix() {
    return {
      className: '📦clearfix',
      styles: "\n.\uD83D\uDCE6clearfix:before, .\uD83D\uDCE6clearfix:after {\n  display: table;\n  clear: both;\n  content: \"\";\n}"
    };
  },
  display: function display(value) {
    return (0, _getCss2.default)(_display, value);
  },
  float: function float(value) {
    return (0, _getCss2.default)(_float, value);
  },
  zIndex: function zIndex(value) {
    return (0, _getCss2.default)(_zIndex, value);
  }
};